module.exports = __webpack_public_path__ + "img/tmartin1.22b8a1fa.png";